module.exports = __webpack_public_path__ + "static/media/Android2.5702ce32.jpg";